import { isValidPrice } from '@domain-group/javascript-utils'

const state = {
  allow_toggle: false,
  data: {
    section_title: '',
  },
  description: undefined,
  display_title: '',
  id: null,
  internal_notes: '',
  item_type: 'custom',
  owner_id: null,
  owner_type: '',
  title: '',
  value_type: 'fixed',
  value: 0,
}

export const requiredFields = [
  { key: 'title' },
  { key: 'value', validation: isValidPrice, invalidMessage: 'Invalid Value' },
  { key: 'value_type' },
]

export default state
